export default __webpack_public_path__ + "assets/7b7c9214b32b389cfebc2c0b180fef1c.jpeg";